export var Tabs = {
  baseStyle: {
    tab: {
      overflow: 'hidden',
      fontWeight: 'bold',
      _current: {
        fontWeight: 'normal'
      },
      _focus: {
        color: 'black',
        boxShadow: "none",
        outline: 'none'
      },
      _disabled: {
        color: 'grey.850',
        bg: 'grey.250'
      }
    },
    tabpanels: {
      border: '1px',
      borderColor: 'grey.300',
      overflow: 'hidden'
    }
  },
  variants: {
    line: props => {
      var {
        orientation
      } = props;
      var isVertical = orientation === 'vertical';
      var borderProp = orientation === 'vertical' ? 'borderStart' : 'borderBottom';
      var marginProp = isVertical ? 'marginStart' : 'marginBottom';
      return {
        tablist: {
          [borderProp]: '4px solid',
          borderColor: 'grey.270'
        },
        tabpanels: {
          border: 'none'
        },
        tab: {
          py: 2,
          px: 4,
          bg: 'grey.250',
          width: '100%',
          [borderProp]: '4px solid',
          borderColor: 'grey.300',
          color: 'blue.600',
          [marginProp]: '-4px',
          _notLast: {
            mr: 1
          },
          _focusWithin: {
            bg: 'yellow.200'
          },
          _selected: {
            bg: 'white',
            color: 'grey.980',
            borderColor: 'grey.950'
          },
          _active: {
            bg: 'blue.1140'
          },
          _disabled: {
            opacity: 1
          }
        }
      };
    },
    enclosed: {
      tabpanels: {
        borderBottomLeftRadius: '0',
        borderBottomRightRadius: '0'
      },
      tab: {
        p: 6,
        ml: 2,
        bg: 'grey.400',
        border: '1px',
        fontSize: 'lg',
        color: 'blue.600',
        borderColor: 'grey.300',
        borderTopLeftRadius: '0',
        borderTopRightRadius: '0',
        borderTop: '6px solid white',
        borderLeft: '2px solid white',
        borderRight: '2px solid white',
        _focusWithin: {
          borderTop: '6px solid white',
          borderLeft: '2px solid white',
          borderRight: '2px solid white',
          bg: 'yellow.200',
          fontWeight: 'bold'
        },
        _selected: {
          borderTop: '6px solid #E5E5E5',
          borderLeft: '2px solid #E5E5E5',
          borderRight: '2px solid #E5E5E5',
          fontWeight: 'normal',
          color: 'grey.980',
          bg: 'white'
        },
        _hover: {
          bg: 'blue.1130',
          color: 'blue.600'
        },
        _active: {
          bg: 'blue.1140',
          color: 'blue.600'
        }
      }
    }
  }
};